<app-header [loginMode]="isLoginRoute"></app-header>

<nav class="menu-container" aria-label="Primary" *ngIf="!isLoginRoute">
  <a class="menu-link" routerLink="/home" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Home</a>
  <a class="menu-link" routerLink="/composers" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Composers</a>
  <a class="menu-link" routerLink="/songs" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Songs</a>
  <a class="menu-link" routerLink="/revels" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Revels</a>
  <a class="menu-link users-link" routerLink="/users" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" *ngIf="currentUserIsAdmin">Users</a>
</nav>

<router-outlet></router-outlet>


